// @flow @jsx h

import { Byline, Video } from '@nrk/dh-feature-components'
import { h } from 'preact'
import PureComponent from 'preact-pure-component'
import style from './index.css'

import type { Props as BaseProps, Viewport } from './types'

type Props = BaseProps & {
  viewport: Viewport
}

class Header extends PureComponent<Props, any> {
  render () {
    const { authors, intro, leadMedia, title } = this.props.data
    const { mediaBaseUrl, viewport } = this.props

    const inlineStyle = {}
    const leadMediaWrapperInlineStyle = {}

    if (viewport.height > -1) {
      if (viewport.width < 720) {
        inlineStyle.height = `${viewport.height - 120}px`
        leadMediaWrapperInlineStyle.height = `${Math.round(
          viewport.height * 0.6
        )}px`
      } else {
        inlineStyle.height = `${viewport.height - 55}px`
      }
    }

    return (
      <header className={style.article__header} style={inlineStyle}>
        <div
          className={style.article__leadMediaWrapper}
          style={leadMediaWrapperInlineStyle}
        >
          <Video
            className={style.article__leadMedia}
            loop
            playing
            muted
            poster={`${mediaBaseUrl}${leadMedia.poster}`}
            sources={leadMedia.sources.map(source => {
              return {
                type: source.type,
                src: `${mediaBaseUrl}${source.src}`
              }
            })}
          />
        </div>
        <div className={style.article__headerText}>
          <h1
            className={style.article__title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p
            className={style.article__intro}
            dangerouslySetInnerHTML={{ __html: intro }}
          />
          <Byline className={style.article__authors} authors={authors} />
        </div>
      </header>
    )
  }
}

export default Header
